import {GetterTree, Module, MutationTree} from "vuex";
import paycoUtils from "@/assets/js/utils";

export class MemberState {
  constructor(token: string | null, phoneNumber: string | null) {
    if (token) {
      this.token = token;
    }

    if (phoneNumber) {
      this.phoneNumber = phoneNumber;
    }
  }

  public token?: string;
  public phoneNumber?: string;
}

const getters: GetterTree<MemberState, any> = {
  hasLogined(state: MemberState): boolean {
    return !paycoUtils.isEmptyString(state.token) || !paycoUtils.isEmptyString(state.phoneNumber);
  },
  isNonMemberLogin(state: MemberState): boolean {
    return paycoUtils.isEmptyString(state.token) && !paycoUtils.isEmptyString(state.phoneNumber);
  }
};

const mutations: MutationTree<MemberState> = {
  setToken(state: MemberState, token: string): void {
    sessionStorage.setItem('token', token);
    state.token = token;
  },

  setPhoneNumber(state: MemberState, phoneNumber: string): void {
    sessionStorage.setItem('phoneNumber', phoneNumber);
    state.phoneNumber = phoneNumber;
  },

  // 회원의 인증정보를 제거하는 메소드
  // 클라이언트에 의해 조작되거나 만료된 토큰이라고 판명된 경우
  // 클라이언트에 의해 조작된 휴대폰번호인 경우
  removeMemberAuthData(state: MemberState): void {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('phoneNumber');

    state.token = '';
    state.phoneNumber = '';
  }
};

export const MemberStore: Module<MemberState, any> = {
  namespaced: true,
  state: new MemberState(sessionStorage.getItem('token'), sessionStorage.getItem('phoneNumber')),
  getters,
  mutations,
};